<script lang="ts">
    import {Flex, Spacer, getPageContext} from 'shared/layouts';
    import {getSutorFondIcon} from 'src/features/erp-sutor/features/generic-record-detail';
    import {RecordFieldsDetailGrid} from 'src/features/erp-sutor/features/record-fields-detail-grid';
    import type {
        DocumentDetailReactivePageData,
        DocumentDetailStaticPageData
    } from 'src/features/record/kp-document-detail-page/types';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import {exists} from 'shared/utils/custom-utils';
    import {getFormattedProjectNameParts} from '../utils';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
    import GenericRecordIcon from 'src/features/erp-sutor/features/generic-record-detail/components/GenericRecordIcon.svelte';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;
    const recordIcon = getSutorFondIcon(model.record.fond);

    $: nameParts = getFormattedProjectNameParts(model.record);
</script>

<Flex direction="column">
    <Flex direction="row" alignItems="center">
        {#if exists(recordIcon)}
            <GenericRecordIcon icon={recordIcon} fond={model.record.fond}/>
            <Spacer direction="horizontal" size="ml"/>
        {/if}

        <Flex direction="row" alignItems="baseline">
            <KpHeading type="h1" size="h2">{nameParts.name}</KpHeading>

            {#if exists(nameParts.projectNumber)}
                <Spacer direction="horizontal" size="sm"/>
                <span class="text-muted">{nameParts.projectNumber}</span>
            {/if}

            <Spacer direction="horizontal" size="ml"/>
            <small class="text-muted">Fond '{pipe(model.record.fond, loc())}' (ID {model.record.fond.id})</small>
        </Flex>
    </Flex>

    <Spacer direction="vertical" size="xxl"/>

    <RecordFieldsDetailGrid record={model.record}/>
</Flex>
